module.exports = __webpack_public_path__ + "static/media/overpass-semibold-italic.d91e16a1.woff2";